import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppLoginService } from '../app-login.service';

@Component({
  standalone: false,
  selector: 'app-login-section',
  templateUrl: './login-section.component.html',
  styleUrls: ['./login-section.component.scss']
})
export class LoginSectionComponent implements OnInit {
  loginForm: FormGroup;
  showPassword: boolean = false;
  submitted: boolean = false;
  capsLockOn: boolean = false;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly router: Router,
    private loginService: AppLoginService,
  ) { }

  ngOnInit(): void {
    this.initLoginForm();
  }

  initLoginForm(): void {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]]
    });
  }

  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }

  onPasswordKeyEvent(event: KeyboardEvent): void {
    const capsOn = event.getModifierState && event.getModifierState('CapsLock');
    this.capsLockOn = capsOn;
  }

  get f() {
    return this.loginForm.controls;
  }

onSubmit(): void {
  console.log('Sign In button clicked');
  this.submitted = true;

  if (this.loginForm.invalid) {
    console.log('Form is invalid');
    return;
  }

  // const loginData = this.loginForm.value;
   let loginData = {
    "username" : this.loginForm.controls['email'].value,
    "password" : this.loginForm.controls['password'].value
  }

  this.loginService.login(loginData).subscribe({
    next: (response) => {
      console.log('API Response:', response);
      // Check if the response status is "success"
      if (response && response.status === 'success') {
        console.log('Authentication successful');
        localStorage.setItem('userEmail', loginData.username);
        this.router.navigate(['my-app']); // Redirect to the my-application page
      } else {
        console.log('Authentication response:', response);
        alert('Invalid email or password. Please try again.');
      }
    },
    error: (error) => {
      console.error('Authentication failed:', error);
      
      // Handle specific error cases
      if (error.status === 401) {
        alert('Invalid email or password. Please check your credentials.');
      } else if (error.status === 422) {
        alert('Invalid request. Please check your input and try again.');
      } else if (error.status === 0) {
        alert('Network error. Please check your internet connection.');
      } else {
        alert('Authentication failed. Please try again later.');
      }
    }
  });
}

  // forgotEmail(): void {
  //   this.router.navigate(['app-login/forgot-email']);
  // }

  forgotEmail(): void {
  console.log('Forgot email link clicked');
  this.router.navigate(['/app-login/forgot-email']);
}

  // forgotPassword(): void {
  //   this.router.navigate(['app-login/find-account']);
  // }
  forgotPassword(): void {
  console.log('Forgot password link clicked - navigating to find account');
  this.router.navigate(['/app-login/find-account']);
}

 complaintPage(): void {
  this.router.navigate(['/complaint-form']);
}
}
